import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [filtersData, setFiltersData] = useState();
   const [MultiChartData, setMultiChartData] = useState();
   const [MultiTable, setMultiTable] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { filtersData, MultiChartData, MultiTable } = JSON.parse(report);
         setFiltersData(filtersData);
         setMultiChartData(MultiChartData);
         setMultiTable(MultiTable);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const getChartsOptionsDefault = () => {
      let option = {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               // Use axis to trigger tooltip
               type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
            },
         },
         grid: {
            top: '3%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: {
            type: 'value',
         },
         yAxis: {
            type: 'category',
            splitLine: {
               lineStyle: {
                  miterLimit: 20,
               },
            },
         },
         series: [
            {
               color: '#000000',
               label: {
                  show: true,
                  position: 'right',
               },
               type: 'bar',
            },
         ],
      };
      return option;
   };
   const mapOptions = (data) => {
      const getColor = (pointType) => {
         switch (pointType) {
            case 'G':
               return '#F383BB';
            case 'S':
               return '#623C21';
            case 'B':
               return '#EDD217';
         }
      };
      let yAxisLabels = data.activities.map((el) => el.activityNameTh);
      let Xdata = data.activities.map((el) => ({
         value: el.participateCount,
         itemStyle: {
            color: getColor(el.pointType),
         },
      }));
      let options = getChartsOptionsDefault();
      options.yAxis.data = yAxisLabels;
      options.series[0].data = Xdata;
      return options;
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>
                  กราฟแสดงจำนวนผู้เข้าร่วมกิจกรรม Top 10
               </div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     ประเภทคะแนน:{' '}
                     {filtersData && filtersData.pointType.length > 0
                        ? filtersData.pointType
                             .map((type) => {
                                const map = {
                                   G: 'with GOVERNANCE',
                                   S: 'through DIGITALIZATION',
                                   B: 'for SOCIETY',
                                };
                                return map[type] || type;
                             })
                             .join(', ')
                        : '-'}
                  </div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className={classes.graphsContainer}>
                  {MultiChartData &&
                     MultiChartData.map((item, index) => (
                        <div key={index} v>
                           <div class='sub-title'>{item.graphName}</div>
                           <ReactECharts
                              option={mapOptions(item)}
                              style={{ height: 300, width: '100%' }}
                           />
                        </div>
                     ))}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[0].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อสังกัด</th>
                              <th>จำนวน</th>
                           </tr>
                           {MultiTable[0].departmentParticipate.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td>{item.participateCount}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[1].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อสังกัด</th>
                              <th>จำนวน</th>
                           </tr>
                           {MultiTable[1].departmentParticipate.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td>{item.participateCount}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
